// ChatHeader.js
import React from "react";
import { Avatar, IconButton, Stack, Typography, Paper } from "@mui/material";
import { IoChevronBack } from "react-icons/io5";
import { ClientEnglishFallback } from "../../constant/ClientEnglishFallback";
import { useSelector } from "react-redux";

const ChatHeader = ({ selectedChat, onBack, isSmallScreen }) => {
  const { multiLanguageData, selectedClientData } = useSelector((state) => state?.main);
  const LANGUAGE = ClientEnglishFallback.ClientChat(multiLanguageData?.ClientChat || {});
  const { TEXT_CHAT } = LANGUAGE;

  return (
    <Paper
      elevation={2}
      sx={{
        display: "flex",
        alignItems: "center",
        p: 1.5,
        bgcolor: "#ffffff",
        borderRadius: "16px 16px 0 0", // Rounded top corners matching container
        borderBottom: "1px solid #f0f0f0",
        position: "sticky",
        top: 0,
        zIndex: 10
      }}>
      <Stack direction="row" alignItems="center" width="100%">
        {isSmallScreen && (
          <IconButton onClick={onBack} sx={{ color: "#555", mr: 1 }}>
            <IoChevronBack size={24} />
          </IconButton>
        )}
        <Avatar
          src={selectedChat?.groupIcon}
          sx={{
            width: 44,
            height: 44,
            mr: 1.5,
            border: "1px solid #eee"
          }}
        />
        <Stack>
          <Typography variant="subtitle1" fontWeight="700" color="#333" lineHeight={1.2}>
            {selectedChat?.groupName || TEXT_CHAT}
          </Typography>
          {/* Optional: Add status or subtitle here if available */}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ChatHeader;
